import './index.styl';

import tpl_try from './try.jst';
import tpl_reminder from './reminder.jst';
import tpl_trial_end from './trial_end.jst';

import { Storage, redirectTo } from '../../../../core/utils';
import { View } from 'backbone.marionette';
import { User } from '../../models';

export default class CoachPopup extends View {
	className() {
		return 'coach-try';
	}

	template() {
		return tpl_try;
	}

	ui() {
		return {
			close: '.js-coach-popup-close',
			forget: '.js-do-not-ask-again',
			more: '.js-more',
			sign_up: '.js-sign-up',
			overlay: '.coach-popup-overlay',
			body: '.coach-popup',
		}
	}

	events() {
		return {
			'click @ui.overlay': 'close',
			'click @ui.close': 'close',
			'click @ui.more': 'onMore',
			'click @ui.sign_up': 'signUp',
			'click @ui.forget': 'forget',
			'click @ui.body': 'preventClose',
		}
	}

	initialize() {
		this.model.set({
			trial_end_in: User.trial_days_to_end
		}, { silent: true });
	}

	switchToPromotionTemplate() {
		this.className = 'coach-try';
		this.template = tpl_try;

		return this;
	}

	switchToReminderTemplate() {
		this.className = 'coach-reminder';
		this.template = tpl_reminder;

		return this;
	}

	switchToTrialEndTemplate() {
		this.className = 'coach-trial-end';
		this.template = tpl_trial_end;

		return this;
	}

	signUp() {
		redirectTo('account/coach-settings')
	}

	close() {
		this.destroy();
	}

	onMore() {
		// const { href } = event.currentTarget;

		// jumpToAnchor(href);

		// this.close();
		redirectTo('/help/coach')
	}

	forget() {
		Storage.set('disable_coach_notifications', true);
		this.close();
	}

	preventClose(event) {
		event.stopPropagation();
	}
}